/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsReturn: {
  name: 'return';
  data: string;
} = {
  name: 'return',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 8c0-1.648-1.882-2.589-3.2-1.6l-5.334 4a2 2 0 0 0 0 3.2l5.334 4c1.318.989 3.2.048 3.2-1.6v-2l4.8 3.6c1.318.989 3.2.048 3.2-1.6V8c0-1.648-1.882-2.589-3.2-1.6L12 10V8Zm-7.333 4L10 8v8l-5.333-4Zm8 0L18 8v8l-5.334-4Z" fill="currentColor"/></svg>`,
};
